export default {
  sources: {
    contractFilter: "Filter by contractual frequency",
    filterAll: "All",
    filterContract: "With contractual frequency ({n})",
    contractBadge: "Contractual frequency: {freq}",
    contractPending: "connector in preparation",
    studyBadge: "Source under study",
    studyOperativa: "Daily query operational since {date}",
    studyNoDisponible: "Unavailable since {date}",
    studyHint: "No official access channel: it is queried daily through legitimate means, with no guaranteed result. While it is unavailable, these events arrive through CIMA when the national authorisation is published, with less notice.",
    title: "Source status",
    loadError: "Couldn't load the data. Check your connection.",
    retry: "Retry",
    disabledDefault: "Source disabled",
    monitoredSince: "Monitored since ",
    last: "Last check: ",
    lastChange: "Last change detected: ",
    next: "Next expected: ",
    runNow: "Run now",
    runScrapeOf: "Run scrape of {name}",
    loading: "Loading sources…",
    queued: "Scrape of “{name}” queued",
    odButton: "Check now",
    odButtonOf: "Check {name} now",
    odHint: "On-demand check: reads a contract source now, without waiting for its schedule. Anything it detects is notified as usual. It only finds what the authority has already published: if it announces something and uploads the document hours later, it will show “no changes” until then. Up to {cap} per source and day for your organisation; not available from 9:00 to 10:00 or during maintenance.",
    odRemaining: "{n} left today",
    odQueued: "Check queued…",
    odQueuedHeavy: "Check queued. This is a high-volume source: it waits for the scheduled reads and may take a while.",
    odRunning: "Checking the source…",
    odDoneNone: "Checked at {time}: no changes",
    odDoneOne: "Checked at {time}: 1 change",
    odDoneSome: "Checked at {time}: {n} changes",
    odFailed: "The check at {time} could not be completed",
    odQueuedMsg: "Check of “{name}” queued",
    odReason_pasada: "Not available during the daily run, until 10:00",
    odReason_mantenimiento: "Not available during scheduled maintenance",
    odReason_en_curso: "A check is already in progress",
    odReason_leyendo: "The source is being read right now; anything it finds will appear when it finishes",
    odReason_tope: "Today's {cap} checks for this source have been used",
    odReason_cola_no_disponible: "Could not be queued; try again in a few minutes",
    odReason_other: "Check not available",
    errorPrefix: "Error: ",
    tomorrow: "Tomorrow {time}",
    statusOk: "Active",
    statusWarning: "Warning",
    statusError: "Error",
    statusPending: "Pending",
    statusInactive: "Inactive",
    serviceOk: "Service operational",
    serviceIncident: "Incident on one or more sources",
    serviceSubtitle: "We monitor {total} official sources continuously · {fresh}/{total} up to date",
  },
};
